export function trapFocus(target: HTMLElement) {

	const interactiveSelectors = [
		'a[href]',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'[tabindex]:not([tabindex="-1"])'
	].join(', ');

	const documentElements = document.querySelectorAll(interactiveSelectors);
	documentElements.forEach((el) => {
		if (!el.hasAttribute('data-inert')) {
			el.setAttribute('data-inert', el.hasAttribute('inert') ? 'true' : 'false');
		}
		el.setAttribute('data-trapped', 'true');
		el.setAttribute('inert', '');
	});

	const targetElements = target.querySelectorAll(interactiveSelectors);
	targetElements.forEach((el) => {
		el.removeAttribute('inert');
		el.removeAttribute('data-trapped');
	});

}

export function releaseFocus() {

	document.querySelectorAll('[data-inert]').forEach((el) => {
		if (el.getAttribute('data-inert') == 'false') {
			el.removeAttribute('inert');
		}
		el.removeAttribute('data-inert');
		el.removeAttribute('data-trapped');
	});

}